import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description?: string;
  canonical?: string;
}

/**
 * 轻量页面级 SEO：设置 document.title 与 meta description / canonical。
 * 由于项目中禁用了 react-helmet-async，采用 React 19 的 useEffect 方式在页面切换时写入。
 */
export default function useSeo({ title, description, canonical }: SeoOptions) {
  useEffect(() => {
    document.title = title;

    const ensureMeta = (attr: "name" | "property", key: string) => {
      let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      return el;
    };

    if (description) {
      ensureMeta("name", "description").content = description;
      ensureMeta("property", "og:description").content = description;
    }

    if (canonical) {
      let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = canonical;
    }
  }, [title, description, canonical]);
}